import {Injectable} from '@angular/core';

import {AlphaLevelService} from '../services/alpha-level/alpha-level.service';

@Injectable({ providedIn: 'root' })
export default class AlphaLevelFacade {
  public enableAll = this._service.enableAll.bind(this._service);
  public level$    = this._service.level$;
  public levels$   = this._service.levels$;

  constructor(private readonly _service: AlphaLevelService) {}

  public updateLevel(id: string): void {
    this._service.updateLevel(id);
  }
}
